import { render, staticRenderFns } from "./SublocationForm.vue?vue&type=template&id=440e99fd&"
import script from "./SublocationForm.vue?vue&type=script&lang=js&"
export * from "./SublocationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports